import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import DiscountCalculator from '../../components/DiscountCalculator'
const default_season = { season: 0, elements: [], includes_tax: true}
const ProductSeason = ({open, close, ...rest}) => {
  const app = React.useContext(AppContext)
  const { selectedProducts, setSelectedProducts, assignSeason, getProducts } = app.products
  const [ productseason, setProductSeason ] = React.useState(default_season)
  const closeForm = () => {
    setSelectedProducts(false)
    setProductSeason(default_season)
  }
  const updateSeason = (season_object) => {
    assignSeason(season_object)
    close()
  }
  const skus = (ps) => ps.reduce((pv, p) => pv ? `${pv}, ${p.sku}` : p.sku, false)
  const name = () => selectedProducts.length === 1? `Asignar descuento temporal a: ${getProducts(selectedProducts)[0].name}`: `Asignar descuento temporal a ${selectedProducts.length} productos con SKUs: (${skus(getProducts(selectedProducts))})`
  React.useEffect(() => {
    if(selectedProducts){
      const p = getProducts(selectedProducts)[0]
      const _productseason = {
        value: p.season, 
        elements: p.season_elements !== ""? p.season_elements.split(",") : [],
        includes_tax: p.includes_tax
      }
      selectedProducts.length === 1? setProductSeason(_productseason) : setProductSeason(default_season)
    }
  }, [selectedProducts])
  
  return (
    <Dialog onClose={closeForm} open={open}>
    {selectedProducts && 
      <React.Fragment>
        <DialogTitle>{name()}</DialogTitle>
        <DiscountCalculator title="Calcular descuento de temporada" label="Descuento Temporal" initial_object={productseason} submit={updateSeason} hideTax={true}/>
      </React.Fragment>
    }
    </Dialog>
  )
}
export default ProductSeason